import { State } from "../../../state";
import { ApplyActionVisibility } from "../_CostsAndOutcomes/ApplyActionVisibility";
import { applyCostsSets } from "../_CostsAndOutcomes/applyCostsSets";
import { ApplyCostScaleChange } from "../_CostsAndOutcomes/ApplyCostScaleChange";
import { meetsCostRequirementsSets } from "../_CostsAndOutcomes/meetsCostRequirementsSets";
import { applyAchievementChecks } from "../../../Achievements/checkAchievements";

/**
 * Generic handler for Upgrade actions that have set costs (and brick costs)
 * Use this for brick pack upgrade actions that require sets
 */
export const Upgrade_Sets_Generic = (actionId: string, state: State) => {
  const newBricks = new Map(state.bricks);
  const newSets = new Map(state.sets);
  const newActions = new Map(state.actions);
  const newActionTimestamps = state.actionTimestamps;
  const newBrickPackUpgrades = new Map(state.brickPackUpgrades);
  const newActionsTriggeredByType = state.actionsTriggeredByType;

  const action = new Map(state.actions).get(actionId)!;

  // Check if action meets cost requirements (both bricks and sets)
  if (!meetsCostRequirementsSets(action, newBricks, newSets)) return state;

  // Apply Action Visibility
  const { newActions: updatedActions, newActionOrder } = ApplyActionVisibility(
    action,
    newActions,
    state.actionOrder,
  );

  // Apply Costs (both bricks and sets)
  const costsResult = applyCostsSets(
    action,
    newBricks,
    newSets,
    newActionTimestamps,
  );
  if (costsResult === null) return state;

  // Apply Upgrade: Increment the upgrade counter for the brick pack
  // For upgrade actions, the outcome[0].brickId contains the brick pack ID
  if (action.outcome.length > 0) {
    const brickPackId = action.outcome[0].brickId;
    const currentUpgrades = newBrickPackUpgrades.get(brickPackId) || 0;
    newBrickPackUpgrades.set(brickPackId, currentUpgrades + 1);
  }

  // Apply Increase in costScale
  ApplyCostScaleChange(action, updatedActions);

  // Apply Achievement Data
  const newActionsAmt = newActionsTriggeredByType.get(actionId) ?? 0;
  newActionsTriggeredByType.set(actionId, newActionsAmt + 1);

  const newState = {
    ...state,
    actionTimestamps: newActionTimestamps,
    bricks: newBricks,
    sets: newSets,
    actions: updatedActions,
    actionOrder: newActionOrder,
    brickPackUpgrades: newBrickPackUpgrades,
    totalActionsTriggered: state.totalActionsTriggered + 1,
    actionsTriggeredByType: newActionsTriggeredByType,
  };

  return applyAchievementChecks(newState);
};
